'use client';
import { memo } from 'react';

import { breakpoints } from 'app/themeConfig';
import { useMobileDevice } from 'shared/hooks';
import TableOfContents from './TableOfContents';
import MobileTableOfContents from './MobileTableOfContents';

const ProjectCaseTableOfContents = ({ navButtonsData }) => {
  const { isMobileDevice } = useMobileDevice(breakpoints.xxl);

  if (isMobileDevice) return <MobileTableOfContents navButtonsData={navButtonsData} />;
  if (!isMobileDevice) return <TableOfContents navButtonsData={navButtonsData} />;
};

export default memo(ProjectCaseTableOfContents);
